<template>
    <div class="time-column" 
        v-bind:class="{
            'hidden': hidden,
            'grid': VIEW_MODES.grid == selectedViewMode,
            'rows': VIEW_MODES.grid != selectedViewMode,
        }">
        <div class="column-title" ref="columnTitle">
            <h4>{{ table.title }}</h4>
            <h6 v-bind:class="{
                'hidden': VIEW_MODES.grid == selectedViewMode,
            }">max.<br>{{ $_formatCurrency(defaultHandicap, true, 1) }}</h6>
        </div>
        <golf-timeblock 
            v-for="(data, index) in table.timeBlocks" :key="data.blockId"
            ref="timeBlock"
            :enableSelection="enableSelection"
            :block="data" 
            @click="reserveBlock({ index, table })"
            @blockChecked="onBlockChecked" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GolfTimeblock from './GolfTimeblock.vue'

export default {
    components: {
        GolfTimeblock
    },
    props: ['table','hidden'],
    data: () => ({
        selectedBlocks: [],
    }),
    computed: {
        ...mapGetters({
            VIEW_MODES: 'golf/VIEW_MODES',
            selectedViewMode: 'golf/selectedViewMode',
            defaultHandicaps: 'golf/defaultHandicaps',
            reviewBlock: 'calendar/reviewBlock',
            loggedIn: 'common/loggedIn',
            requireLoggedIn: 'common/requireLoggedIn',
            admin: 'common/admin',
            adminMode: 'common/adminMode',
            additionalResources: 'reservations/additionalResources',
            generateReservation: 'reservations/generateReservation',
            TIMEBLOCK_TYPE: 'reservations/TIMEBLOCK_TYPE',
            isEmbed: 'common/isEmbed',
        }),
        defaultHandicap() {
            return this.defaultHandicaps[this.table.resourceId] || null;
        },
        enableSelection() {
            if (this.isEmbed) {
                return false;
            }

            return true;
        }
    },
    methods: {
        onBlockChecked(data) {
            const { $event, blockChecked, block } = data;

            if (blockChecked) {
                this.selectedBlocks.push(block.blockId);
            } else {
                const index = this.selectedBlocks.indexOf(block.blockId);

                if (index > -1) {
                    this.selectedBlocks.splice(index, 1);
                }
            }
            const blocks = this.selectedBlocks.map(blockId => {
                const block = this.table.timeBlocks.filter(row => row.blockId === blockId)[0]
                const { start, end, reservations } = block;
                return { start, end, reservations };
            }).filter(row => row.reservations.length > 0);
            //console.log('onBlockChecked', blocks)
            this.$store.commit('golf/setSelectedTeeTimes', blocks)
        },
        deselectAll() {
            if (this.hidden) return;

            this.$refs.timeBlock.forEach((elem) => elem.setChecked(false));
            this.$store.commit('golf/setSelectedTeeTimes', []);
            this.selectedBlocks = [];
        },
        reserveBlock(data) {
            const { index, table } = data;
            const TIMEBLOCK_TYPE = this.TIMEBLOCK_TYPE;
            
            if (!this.loggedIn && this.requireLoggedIn) {
                return this.$_swal({
                    title: this.$_locale('you have to be logged in to reserve'),
                    text: '',
                    type: 'warning',
                    showCancelButton: true,
                    cancelButtonClass: 'btn-default',
                    confirmButtonClass: 'btn-warning',
                    confirmButtonText: this.$_locale('Login'),
                    cancelButtonText: this.$_locale('cancel')
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        setTimeout(() => {
                            if (this.isEmbed) {
                                const postData = {
                                    type: 'login',
                                }
                                
                                window.top.postMessage(JSON.stringify(postData), '*');
                            } else {
                                document.querySelector('#loginModalLink').click()
                            }
                        }, 350);
                    } else {
                        
                    }
                })
            }
            
            if (!this.reviewBlock(data)) {
                const block = table.timeBlocks[index];
                let showReservationModal = false;

                if (this.adminMode && block.type !== TIMEBLOCK_TYPE.disabledByRule) {
                    const reservation = this.generateReservation(index, table);
                    const longDisabledTimes = reservation.reservations
                        .filter(row => row.status === 4)
                        .filter(row => {
                            const start = moment(row.start);
                            const end = moment(row.end);
                            const diff = Math.abs(moment(start).diff(moment(end), 'minutes'));

                            return diff > reservation.duration;
                        })
                    
                    if (longDisabledTimes.length > 0) {
                        this.$store.commit('calendar/setActiveReservation', reservation)
                        this.$store.commit('common/setModal', 'listreservations')
                    } else {
                        showReservationModal = true;
                    }
                } else {
                    if (block.info.length > 0) {
                        this.$_swal({ icon: block.type !== TIMEBLOCK_TYPE.reservation ? 'error' : 'success', title: block.info })
                    }
                }

                if (!showReservationModal) {
                    return false;
                }
            }
            const reservation = this.generateReservation(index, table);
            //console.log('reserveBlock', reservation);
            
            if (this.adminMode) {
                
            } else {
                
            }
            
            this.$store.commit('calendar/setActiveReservation', reservation)
            this.$store.commit('common/setModal', 'golfreservation')
            
            if (Array.isArray(this.additionalResources) 
                && this.additionalResources.length > 0) {
                this.$store.dispatch('calendar/updateAvailableAdditionalResources', true)
            }
        }
    },
    mounted() {
        try {
            const stickyEl = this.$refs.columnTitle;
            const observer = new IntersectionObserver(
                ([e]) => {
                    e.target.classList.toggle('is-floating', e.intersectionRatio < 1) 
                },
                {
                    rootMargin: '-1px 0px 0px 0px',
                    threshold: [1]
                }
            );

            observer.observe(stickyEl)
        } catch(e) {
            console.warn(e);
        }
    },
}
</script>
